var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 100,
    viewBox: "0 0 52 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7538 100C50.331 100 50.9081 99.778 51.3427 99.334C52.2191 98.4532 52.2191 97.0211 51.3427 96.1332L5.42924 49.9964L51.3427 3.85961C52.2191 2.97883 52.2191 1.54668 51.3427 0.658749C50.4663 -0.222024 49.0413 -0.222024 48.1578 0.658749L0.655496 48.3995C0.235121 48.822 -2.10476e-06 49.402 -2.10476e-06 49.9964C-2.10476e-06 50.5979 0.235121 51.1707 0.655496 51.5932L48.165 99.3412C48.5996 99.7851 49.1767 100 49.7538 100Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.dd968c55f71509a382a881464669d5ca.svg";
export { ForwardRef as ReactComponent };